import Backdrop from "../Bootstrap/util/backdrop";

let backdrop = null;

/**
 * Programové zavření otevřeného offcanvas menu včetně úklidu backdropu.
 * Když menu otevřené není (např. desktop režim), neudělá nic.
 *
 * Typické použití: menu obsahuje kotvové odkazy (href="#sekce") a po kliku na kotvu
 * se má menu zavřít. Handler patří do projektového index.ts a jeho selektor MUSÍ
 * vyloučit dropdown toggly — ty mají href="#" a přímý listener na <a> doběhne dřív
 * než delegovaný Bootstrap dropdown handler, takže bez výjimky se menu zavře a
 * dropdown se otevře ve skrytém panelu. Filtr nestavět na třídě .dropdown-toggle
 * (v projektových menu nemusí být), spolehlivý je jen atribut data-bs-toggle:
 *
 *     document.querySelectorAll('.offcanvas-collapse a[href^="#"]:not([href="#"]):not([data-bs-toggle])')
 *         .forEach(function (link) {
 *             link.addEventListener('click', function () {
 *                 OffcanvasMenu.close();
 *             });
 *         });
 */
export function close() {
    let area = document.querySelector('.offcanvas-collapse');
    if (area === null || !area.classList.contains('open')) {
        return;
    }

    area.classList.remove('open');

    if (backdrop !== null) {
        backdrop.dispose();
        backdrop = null;
    }
}

export function initialize() {
    document.querySelector('#navbarSideCollapse').addEventListener('click', function () {
        let toggleButton = this;
        let area = document.querySelector('.offcanvas-collapse');
        area.classList.toggle('open');

        if(backdrop === null) {
            backdrop = new Backdrop({
              isVisible: true,
              isAnimated: true,
              rootElement: area.parentNode,
              clickCallback: function() {
                 toggleButton.click();
                 backdrop.dispose();
                 backdrop = null;
              }
            });

            backdrop.show();
        }
    });
}
